import React, { useState, useEffect, Fragment } from 'react';
import Header from './Header';
import DefaultSidebar from './Sidebar'
import { Card, Typography } from "@material-tailwind/react";
import axios from 'axios';
import ModalCreateWireguard from './ModalCreateWireguard'
import ModalModifyWireguard from './ModalModifyWireguard';

function ListClientWireguard() {
    // const [open, setOpen] = useState('block')
    const [datas, setDate] = useState([])
    const [sortedBy, setSortedBy] = useState()
    const [counter, setCounter] = useState(0)
    const [search, setSearch] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [showModalModify, setShowModalModify] = useState(false);
    const [choosenClientWireguard, setchoosenClientWireguard] = useState({
        id: '', 
        nom: '', 
        adresse_ip:''
    });
    useEffect(() => {

        axios.get(`${process.env.REACT_APP_IP}:${process.env.REACT_APP_PORT}/get_client_wireguard`)
            .then(res => {
                // console.log(res.data);
                setDate(res.data)
            }).catch(err => console.log(err))
    }, [])
    
    const TABLE_HEAD = [
        { key: "nom", text: "Nom Client" },
        { key: "adresse_ip", text: "Adresse IP" }
    ];

    const sorted = datas.sort((a, b) => {

        const aVal = a[sortedBy];
        const bVal = b[sortedBy];
        if (typeof aVal === "number" && typeof bVal === "number") {
            if (counter % 2 === 0) return aVal - bVal;
            else return bVal - aVal;
        }
        else if (typeof aVal === "string" && typeof bVal === "string") {
            if (counter % 2 === 0) return aVal.localeCompare(bVal);
            else return bVal.localeCompare(aVal);
        }
        return 1;
    });

    const scrollToTop = () =>{ 
        window.scrollTo({ 
          top: 0,  
          behavior: 'smooth'
        }); 
      };

    const ListTable = (() => {
        return (
            <div className="w-full overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm">
                <div className="overflow-x-auto">
                    <table className="w-full min-w-max table-auto text-left">
                        <thead className="border-b border-slate-200 bg-slate-50">
                            <tr>
                                {TABLE_HEAD.map((head) => (
                                    <th
                                        key={head.key}
                                        className="cursor-pointer whitespace-nowrap px-4 py-3 text-xs font-semibold uppercase tracking-wide text-slate-500 hover:text-slate-700"
                                        onClick={() => { setSortedBy(head.key); setCounter(counter + 1) }}
                                    >
                                        <span className="inline-flex items-center gap-1">
                                            {head.text}
                                            {sortedBy === head.key && (
                                                <span className="text-indigo-500">{counter % 2 === 0 ? '▲' : '▼'}</span>
                                            )}
                                        </span>
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {sorted.filter((item) => {
                                return search.toLowerCase() === ''
                                    ? item
                                    : item.nom.toLowerCase().includes(search.toLowerCase()) || item.adresse_ip.toLowerCase().includes(search.toLowerCase())
                            }).map((data, index) => {
                                return (
                                    <tr key={data.id} className='cursor-pointer border-b border-slate-100 transition-colors hover:bg-indigo-50/40' onClick={() => {setShowModalModify(true); setchoosenClientWireguard({...choosenClientWireguard, id: data.id, nom: data.nom, adresse_ip: data.adresse_ip })}}>
                                    {/* // <tr key={data.id} > */}
                                        <td className="whitespace-nowrap px-4 py-3 text-sm text-slate-700">
                                            {data.nom}
                                        </td>
                                        <td className="whitespace-nowrap px-4 py-3 text-sm text-slate-700">
                                            {data.adresse_ip}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    })

    return (
        <Fragment>
            <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6">
                {/* <Header /> */}
                <div className="mb-6">
                    <h1 className="text-xl font-semibold text-slate-800">Clients Wireguard</h1>
                    <p className="text-sm text-slate-500">Gérez les clients Wireguard et leurs adresses IP.</p>
                </div>
                <div className='mb-4 max-w-md'>
                    {/* <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8 absolute left-1 cursor-pointer" onClick={() => setOpen(open === `hidden`  ? 'block' : 'hidden')} >
                        <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
                    </svg> */}
                    <div className="relative flex h-10 items-center rounded-xl border border-slate-200 bg-white shadow-sm focus-within:border-indigo-500 focus-within:ring-2 focus-within:ring-indigo-500/20">
                    <svg xmlns="http://www.w3.org/2000/svg" className="ml-3 h-5 w-5 text-slate-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                    </svg>

                    <input
                        className="h-full w-full rounded-xl bg-transparent px-3 text-sm text-slate-800 placeholder-slate-400 outline-none"
                        type="text"
                        id="search"
                        placeholder="Rechercher..."
                        onChange={(e) => setSearch(e.target.value)} />
                </div>
                </div>
                <main className="mt-4">
                    {/* <DefaultSidebar  isOpen={open} /> */}
                    {ListTable()}


                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-10 h-10 fixed bottom-16 right-6 	cursor-pointer" onClick={() => scrollToTop() }>
                      <path strokeLinecap="round" strokeLinejoin="round" d="M15 11.25l-3-3m0 0l-3 3m3-3v7.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>

                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-10 h-10 fixed bottom-6 right-6 cursor-pointer" onClick={() => setShowModal(true)}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M19 7.5v3m0 0v3m0-3h3m-3 0h-3m-2.25-4.125a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zM4 19.235v-.11a6.375 6.375 0 0112.75 0v.109A12.318 12.318 0 0110.374 21c-2.331 0-4.512-.645-6.374-1.766z" />
                    </svg>
                </main>
            </div>
                    <ModalModifyWireguard isVisible={showModalModify} onClose={() => setShowModalModify(false)} choosenClientWireguard={choosenClientWireguard}/>
                    <ModalCreateWireguard isVisible={showModal} onClose={() => setShowModal(false)} /> 
                    </Fragment>
            
    )
}
export default ListClientWireguard;